export default __webpack_public_path__ + "media/5b4f79b8337ab851066ae6c45f4e2d6f1859bf72b25cf97ea28586af5878d66a.svg";